
import { HttpErrorResponse } from '@angular/common/http';
import { createReducer, on } from '@ngrx/store';
import * as FeatureFlagActions from './featureFlags.actions';
import * as _ from 'lodash';
import { FeatureFlagsTemplate } from './../../../app/@shared/models/featureFlags';

export const featureFlagTemplatesFeatureKey = 'templates_feature_flags';

export interface State {
  loaded: boolean;
  loading: boolean;
  templates_feature_flags: Array<FeatureFlagsTemplate>;
  error?: Error | HttpErrorResponse;
  default_feature_flag_loaded: boolean;
  default_feature_flag_loading: boolean;
  default_feature_flag: Partial<FeatureFlagsTemplate> | undefined;
}

export const initialState: State = {
  loaded: false,
  loading: false,
  templates_feature_flags: [],
  default_feature_flag_loaded: false,
  default_feature_flag_loading: false,
  default_feature_flag: undefined
};

export const reducer = createReducer(
  initialState,

  on(FeatureFlagActions.loadFeatureFlags, (state, action) => ({
    ...state,
    loading: true
  })),

  on(FeatureFlagActions.loadFeatureFlagsSuccess, (state: State, action) => ({
    ...state,
    loaded: true,
    loading: false,
    templates_feature_flags: action.featureFlags,
    error: undefined
  })),

  on(FeatureFlagActions.loadFeatureFlagsFailure, (state, action) => ({
    ...state,
    loading: false,
    error: action.error
  })),

  on(FeatureFlagActions.loadDefaultFeatureFlagsSuccess, (state: State, action) => ({
    ...state,
    default_feature_flag_loaded: true,
    default_feature_flag_loading: false,
    default_feature_flag: action.featureFlags
  }))
);
